module.exports = __webpack_public_path__ + "assets/img/station4.af4431a3.png";